<template>
	<VInputMask
		ref="company-USt-IdNr-input"
		:value="company.additionalAttributes.ustIdnr.value"
		:label="company.additionalAttributes.ustIdnr.name"
		layout="vertical"
		:tokens="{
        '#': { pattern: /\d/ },
      }"
		mask="DE#########"
		masked
		:validate-method="DeUtils.validateUStIdNr"
		:disabled="readOnly"
	/>

	<VInputMask
		ref="company-lei-input"
		:value="company.additionalAttributes.lei.value"
		:label="company.additionalAttributes.lei.name"
		layout="vertical"
		:tokens="{
        '#': { pattern: /\d/ },
        X: { pattern: /[\dA-Z]/ },
      }"
		mask="XXXX-XX-XXXXXXXXXXXX-##"
		:validate-method="DeUtils.validateLEI"
		:disabled="readOnly"
	/>
</template>

<script>

import DeUtils from '@/core/utils/regional/DeUtils'
import Company from "@/domains/Companies/Company.js";

export default {
	name:   'DEAdditionalAttributes',

	props: {
    company: {
      type:     Company,
      required: true
    },
		readOnly: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			DeUtils,
		}
	},
};
</script>
